//Dependencies
import React from 'react';
import { Affix } from 'antd';
import { InfoFilledIcon } from '../../../icons/icons';
import { useDispatch } from 'react-redux';

/* SIDEMENU */
const Sidemenu02 = (props) =>
{
  const { height, counter, portfolioArray } = props; 
  const dispatch = useDispatch();

  const clickInfo = () =>
  {
    dispatch({type: 'SET_DRAWER_02', drawer02 : true});
  };

  const clickArrows = (value) =>
  {
    let newCounter = counter + value;
    
    if(newCounter < 0)
    {
      newCounter = portfolioArray.length - 1;
    }
    else if(newCounter > portfolioArray.length - 1)
    {
      newCounter = 0;
    }    
    
    dispatch({type: 'SET_PORTFOLIO_COUNTER', counter : newCounter});
  };
 
  return(
    <Affix 
      style = {{ position: "fixed", bottom: height, right: 10, zIndex : 1000}}
    >
      <div>
        <div 
          className = "flex items-center justify-center text-white p-3 text-center mb-2 md:mb-4 lg:mb-5 lg:w-16 lg:h-16 w-12 h-12 shadow-lg rounded-full cursor-pointer bg-gray-800 hover:bg-sky-600"
          //onClick   = {() => clickArrows(-1)}
        >
          <i className = "fa fa-heart flex text-xl lg:text-2xl flex cursor-pointer " ></i>
        </div>

        <div 
          className = "flex items-center justify-center text-white p-3 text-center mb-2 md:mb-4 lg:mb-5 lg:w-16 lg:h-16 w-12 h-12 shadow-lg rounded-full cursor-pointer bg-gray-800 hover:bg-sky-600"
          onClick   = {() => clickArrows(-1)}
        >
          <i className = "fas fa-arrow-up flex text-xl lg:text-2xl flex cursor-pointer " ></i>
        </div>

        <div 
          className = "flex items-center justify-center text-white p-3 text-center mb-2 md:mb-4 lg:mb-5 lg:w-16 lg:h-16 w-12 h-12 shadow-lg rounded-full cursor-pointer bg-gray-800 hover:bg-sky-600"
          onClick   = {() => clickArrows(1)}
        >
          <i className = "fas fa-arrow-down flex text-xl lg:text-2xl flex cursor-pointer " ></i>
        </div>
       
        <div 
          className = "flex items-center justify-center text-white p-3 text-center mb-2 md:mb-4 lg:mb-5 lg:w-16 lg:h-16 w-12 h-12 shadow-lg rounded-full cursor-pointer bg-gray-800 hover:bg-sky-600"
          onClick   = {() => clickInfo()}
        >
          <InfoFilledIcon className = ' text-xl lg:text-2xl flex cursor-pointer'/>
        </div>
      </div>
    </Affix>
  );
}

export default Sidemenu02;